import React from "react";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { FollowingBranchesList } from "../../../../model/notices/FollowingBranchListMode";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { textCase } from "../../../../service/ui/UI";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import Div from "../../../../widget/common/ui/Div";
import { CheckBoxRound } from "../../../../widget/common/ui/Checkbox";

const FollowingListing = (props: {
  branches: Array<FollowingBranchesList> | null;
  onClick: (detail: FollowingBranchesList) => void;
  selectedBranchIds: Array<string>;
  type?: number | undefined;
  deleteStatus: boolean;
}) => {
  const branches = props.branches ?? null;
  const deleteStatus = props.deleteStatus ?? false;
  const selectedBranchIds = props.selectedBranchIds ?? [];
  const type: number = props.type ?? ResponsiveDeviceType();

  return (
    <>
      {branches != null && (
        <Listing>
          {(branches ?? []).map((branch, key) => (
            <ListItem key={key}>
              <div
                role={deleteStatus ? "button" : "none"}
                onClick={() => props.onClick(branch)}
                className="d-flex align-items-center justify-content-between"
              >
                <Div>
                  <TextBlock
                    fontName="bold"
                    fontSize="16_17"
                    textColor="theme-label"
                  >
                    {textCase(branch?.branch_title!)}
                  </TextBlock>
                  <SpacingHeight value={type === 1 ? 2 : type === 2 ? 3 : 5} />
                  {UtilityHelper.isNotEmpty(branch?.branch_description!) && (
                    <>
                      <TextBlock
                        fontName="book"
                        fontSize="13_14"
                        textColor="theme-sublabel"
                      >
                        {textCase(branch?.branch_description!)}
                      </TextBlock>
                      <SpacingHeight
                        value={type === 1 ? 2 : type === 2 ? 3 : 5}
                      />
                    </>
                  )}

                  <TextBlock
                    fontName="book"
                    fontSize="13_14"
                    textColor="theme-sublabel"
                  >
                    {UtilityHelper.isNotEmpty(branch?.area_name!)
                      ? `${textCase(branch?.area_name!)}, `
                      : ""}
                    {textCase(branch?.city_name!)}
                  </TextBlock>
                  <SpacingHeight value={type === 1 ? 2 : type === 2 ? 3 : 5} />
                  <TextBlock
                    fontName="book"
                    fontSize="13_14"
                    textColor="theme-sublabel"
                  >
                    {textCase(branch?.state_name!)},{" "}
                    {textCase(branch?.country_name!)}
                  </TextBlock>
                </Div>
                {deleteStatus && (
                  <CheckBoxRound
                    status={selectedBranchIds.includes(branch?.branch_id!)}
                  />
                )}
              </div>
            </ListItem>
          ))}
        </Listing>
      )}
    </>
  );
};

export default FollowingListing;
